// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","title":"tabView_title__Q5syo","user-menu":"tabView_user-menu__11upj","user-item":"tabView_user-item__1Qf6d","user-links":"tabView_user-links__3SJ6b"};